import React, { useState } from "react";
import swal from "sweetalert";
import { FiChevronDown } from "react-icons/fi";

import { submitDemoRequestToSharePoint } from "../utils/submitDemoRequestToSharePoint";

import "../assets/css/RequestQuote.css";

const RequestQuote = ({
  title,
}) => {
  const [submitting, setSubmitting] = useState(false);

  const [fullName, setFullName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [service, setService] = useState("");
  const [position, setPosition] = useState("");
  const [description, setDescription] = useState("");

  const submitHandler = async (e) => {
    e.preventDefault();

    setSubmitting(true);

    try {
      await submitDemoRequestToSharePoint({
        fullName,
        phoneNumber,
        companyName,
        position,
        email,
        service,
        description,
        channel: "Contact Page Form",
      });

      swal({
        title: "Your request has been submitted successfully!",
        icon: "success",
        button: "Close",
      });

      setFullName("");
      setPhoneNumber("");
      setEmail("");
      setCompanyName("");
      setService("");
      setPosition("");
      setDescription("");
    } catch (error) {
      console.error(error);

      swal({
        title: "We couldn't submit your request.",
        text: "Please try again or email us at info@outcess.com.",
        icon: "error",
        button: "Close",
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="request-quote">
      <div className="request-quote-container container">
       {title && <h2>{title}</h2>}

        <form onSubmit={submitHandler}>
          <div className="form-grid">
            <div className="form-group">
              <label>Full Name</label>

              <input
                type="text"
                name="fullName"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label>Phone Number</label>

              <input
                type="text"
                name="phoneNumber"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label>Email Address</label>

              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label>Company Name</label>

              <input
                type="text"
                name="companyName"
                value={companyName}
                onChange={(e) => setCompanyName(e.target.value)}
                required
              />
            </div>

            <div className="form-group relative">
              <label>Service</label>

              <select
                name="service"
                value={service}
                onChange={(e) => setService(e.target.value)}
                required
                className="rounded-md "
              >
                <option value="">Select a service </option> 

                <option value="Business Process Outsourcing">
                  Business Process Outsourcing
                </option>

                <option value="AI Driven Customer Engagement Solutions">
                  AI Driven Customer Engagement Solutions
                </option>

            <option value="AI Governance Lifecycle">
             AI Governance Lifecycle
                </option>

                <option value="AI Debt Recovery">
                  AI Debt Recovery
                </option>

                <option value="Agentic AI">
                  Agentic AI
                </option>
              </select>
               <FiChevronDown
                className="pointer-events-none absolute right-3 top-[70%] -translate-y-1/2"
                size={18}
              />
            </div>

            <div className="form-group">
              <label>Position / Designation</label>

              <input
                type="text"
                name="position"
                value={position}
                onChange={(e) => setPosition(e.target.value)}
                required
              />
            </div>
          </div>

          <div className="form-group full-width">
            <label>Message</label>

            <textarea
              name="description"
              rows="6"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Please describe what you need..."
              required
            />
          </div>

          <button
            type="submit"
            disabled={submitting}
            className="ccsnl-btn"
          >
            {submitting
              ? "Submitting Request..."
              : "Book a Demo"}
          </button>
        </form>
      </div>
    </section>
  );
};

export default RequestQuote;
